import React from 'react';
import PropTypes from 'prop-types';

import Heading from 'zignal-landscape/lib/Heading';
import Col from 'zignal-landscape/lib/Col';

const SettingsPageHeader = ({headingText, italicText}) => {
  return (
    <Col xs={12}>
      <Heading>{headingText}</Heading>
      <i>{italicText}</i>
      <br />
      <br />
    </Col>
  );
};

SettingsPageHeader.propTypes = {
  headingText: PropTypes.string,
  italicText: PropTypes.string
};

export default SettingsPageHeader;
